import React, { useEffect, useState } from "react";
import Loader from "../Loader";
import Header_en from "./Header_en";
import Footer_en from "./Footer_en";

const Actualites_en = () => {
  const handleClick = (event) => {
    event.preventDefault(); // Prevent the default action
    console.log("Link click prevented!");
  };
  // State to control visibility
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    document.documentElement.lang = "en";
    // Delay the visibility of the component
    const timer = setTimeout(() => {
      setIsVisible(true); // Set to visible after the delay
    }, 200);

    return () => clearTimeout(timer); // Clean up on unmount
  }, []);
  return (
    <div>
      <div>
        <Header_en />
      </div>
      <Loader isVisible={isVisible} />
      <div>
        <section
          className="page-title bg-overlay-black-60 parallax"
          style={{
            backgroundImage:
              "url(/assets/images/actualité/slider-actualite.png)",
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="page-title-name">
                  <h1>NEWS</h1>
                  <p>What's new at SACEM?</p>
                </div>
                <ul className="page-breadcrumb">
                  <li>
                    <a href="/en">
                      <i className="fa fa-home" /> Home
                    </a>{" "}
                    <i className="fa fa-angle-double-right" />
                  </li>
                  <li>
                    <span>news</span>{" "}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        {/*=================================
page-title */}
        {/*=================================
 Grid-1 */}
        <div className="page-section-ptb">
          <section className="page-section-pb white-bg">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-lg-8">
                  <div className="section-title text-center">
                    <h6>NEWS</h6>
                    <h2 className="title-effect"> SACEM GROUP</h2>
                  </div>
                </div>
              </div>
              {/** row 1 */}
              <div className="row">
                {/** actu 1 */}
                <div className="col-lg-6 col-md-6 col-sm-6">
                  <div className="blog-entry mb-50">
                    <div className="entry-image clearfix">
                      <div
                        className="owl-carousel bottom-center-dots"
                        data-nav-dots="ture"
                        data-items={1}
                        data-md-items={1}
                        data-sm-items={1}
                        data-xs-items={1}
                        data-xx-items={1}
                      >
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/sante_tenja/ST1.jpg"
                            alt="Engagement social SACEM INDUSTRIES"
                            //style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/sante_tenja/ST2.jpg"
                            alt="Engagement social SACEM INDUSTRIES"
                            //style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/sante_tenja/ST3.jpg"
                            alt="Engagement social SACEM INDUSTRIES"
                            //style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/sante_tenja/ST4.jpg"
                            alt="Engagement social SACEM INDUSTRIES"
                            //style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/sante_tenja/ST5.jpg"
                            alt="Engagement social SACEM INDUSTRIES"
                            //style={{ maxHeight: "309px" }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="blog-detail" style={{ minHeight: "1160px" }}>
                      <div className="entry-title mb-10">
                        <a href="#" onClick={handleClick}>
                          Tinga Basic Health Center, in the governorate of Bizerte
                        </a>
                      </div>
                      <div className="entry-meta mb-10">
                        <ul>
                          <li>
                            {" "}
                            <i className="fa fa-folder-open-o" />{" "}
                            <a href="#" onClick={handleClick}>
                              {" "}
                              SACEM Industries News{" "}
                            </a>{" "}
                          </li>

                          <li>
                            <a href="#" onClick={handleClick}>
                              <i className="fa fa-calendar-o" /> Decembre 2025
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="entry-content">
                        <p>
                          To conclude #2025 with meaningful action, SACEM Industries  صـاسـام للصــناعــات carried out a humanitarian initiative in support of local healthcare facilities. As part of our Corporate Social Responsibility commitment and following a proposal from Mrs. Yosra Abbas (Bizerte Regional Council) and the supervision of Mr. Adnen Ben Bekri (Director of the Menzel Bourguiba Regional Hospital), our teams renovated the Primary Healthcare Center of Tinja – Bizerte Governorate.
                        </p>
                        <p>
                          🛠️ Our intervention included:
                        </p>
                        <ul>
                          <li>
                            Wall repairs and full repainting.
                          </li>
                          <li>Maintenance of doors and locks.</li>
                          <li>
                            Refurbishment of exterior pathways & installation of a new protective canopy.
                          </li>
                          <li>
                            Improvement of the main entrance and signage for better patient flow.
                          </li>
                        </ul>
                        <p>
                          This initiative reflects our dedication to supporting our surrounding community and reinforcing public healthcare infrastructure for the residents of Tinja.
                        </p>
                        <p>
                          🙏 Mr. Khaled Kammoun extends his sincere thanks to the SACEM Industries team:
                        </p>
                        <ul>
                          <li>M. Mehdi Ben Hadada</li>
                          <li>M. Louati Traïa</li>
                          <li>M. Ahmed Ben Ammar</li>
                          <li>M. Kamal Deridi</li>
                          <li>M. Khaled Ben Zitoune</li>
                          <li>M. Noureddine Ben Mohamed</li>
                          <li>M. Mahmoud Tunisi</li>
                          <li>M. Aymen El Gharbi</li>
                        </ul>
                        <p>
                          Your professionalism and human commitment turned a simple gesture into meaningful impact.
                        </p>
                        <p>
                          🤝 Together, we build positive and lasting change..
                        </p>
                        <p>
                          #PowerTransformer #EnergyInfrastructure
                          #IndustrialTechnology #SACEM #Transformer #Tunisia
                          #Africa
                        </p>
                      </div>
                    </div>
                    <div
                      className="entry-share clearfix"
                      style={{
                        marginTop: "0px",
                        paddingBottom: "1.25rem",
                        paddingRight: "1.25rem",
                        paddingTop: "0.5rem",
                      }}
                    >
                      <div className="social list-style-none float-right">
                        <strong>Follow us: </strong>
                        <ul>
                          <li>
                            <a href="https://www.facebook.com/sacemgroup/?locale=fr_FR">
                              {" "}
                              <i className="fa fa-facebook" />{" "}
                            </a>
                          </li>
                          <li>
                            <a href="https://fr.linkedin.com/company/sacem-group">
                              {" "}
                              <i className="fa ti-linkedin" />{" "}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                {/** actu 2 */}
                <div className="col-lg-6 col-md-6 col-sm-6">
                  <div className="blog-entry mb-50">
                    <div className="entry-image clearfix">
                      <div
                        className="owl-carousel bottom-center-dots"
                        data-nav-dots="ture"
                        data-items={1}
                        data-md-items={1}
                        data-sm-items={1}
                        data-xs-items={1}
                        data-xx-items={1}
                      >
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/Stages PFE 2026/ENIB1.jpg"
                            alt="Engagement social SACEM INDUSTRIES"
                            //style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/Stages PFE 2026/ENIB2.jpg"
                            alt="Engagement social SACEM INDUSTRIES"
                            //style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/Stages PFE 2026/ENIB3.jpg"
                            alt="Engagement social SACEM INDUSTRIES"
                            //style={{ maxHeight: "309px" }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="blog-detail" style={{ minHeight: "1160px" }}>
                      <div className="entry-title mb-10">
                        <a href="#" onClick={handleClick}>
                          Business Day organised by the National Engineering
                          School of Bizerte (ENIB)
                        </a>
                      </div>
                      <div className="entry-meta mb-10">
                        <ul>
                          <li>
                            {" "}
                            <i className="fa fa-folder-open-o" />{" "}
                            <a href="#" onClick={handleClick}>
                              {" "}
                              SACEM Industries News{" "}
                            </a>{" "}
                          </li>

                          <li>
                            <a href="#" onClick={handleClick}>
                              <i className="fa fa-calendar-o" /> 26 November
                              2025
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="entry-content">
                        <p>
                          Our wonderful team presented several End-of-Study
                          Project (ESP) topics to engineering students, with the
                          aim of strengthening the link between academia and
                          industry, and offering future graduates concrete
                          opportunities for learning and innovation.
                        </p>
                        <p>
                          Thank you to ENIB for the warm welcome and impeccable
                          organisation. We are delighted to contribute to the
                          training of tomorrow's leaders.
                        </p>
                        <p>
                          Thanks also to our wonderful team: Amine Taamallah,
                          Amine Sradkia, Mohamed Lamine Hassine, Aymen Rezgui,
                          and Ayoub Marzouki.
                        </p>
                        <p>
                          #PowerTransformer #EnergyInfrastructure
                          #IndustrialTechnology #SACEM #Transformer #Tunisia
                          #Africa #ENIB #PFE #Partnership #Engineering
                          #Industries #Talents
                        </p>
                      </div>
                    </div>
                    <div
                      className="entry-share clearfix"
                      style={{
                        marginTop: "0px",
                        paddingBottom: "1.25rem",
                        paddingRight: "1.25rem",
                        paddingTop: "0.5rem",
                      }}
                    >
                      <div className="social list-style-none float-right">
                        <strong>Follow us: </strong>
                        <ul>
                          <li>
                            <a href="https://www.facebook.com/sacemgroup/?locale=fr_FR">
                              {" "}
                              <i className="fa fa-facebook" />{" "}
                            </a>
                          </li>
                          <li>
                            <a href="https://fr.linkedin.com/company/sacem-group">
                              {" "}
                              <i className="fa ti-linkedin" />{" "}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/** row 1 */}
              <div className="row">
                {/** actu 1 */}
                <div className="col-lg-6 col-md-6 col-sm-6">
                  <div className="blog-entry mb-50">
                    <div className="entry-image clearfix">
                      <div
                        className="owl-carousel bottom-center-dots"
                        data-nav-dots="ture"
                        data-items={1}
                        data-md-items={1}
                        data-sm-items={1}
                        data-xs-items={1}
                        data-xx-items={1}
                      >
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/Stages PFE 2026/UC1.jpg"
                            alt="Engagement social SACEM INDUSTRIES"
                            //style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/Stages PFE 2026/UC2.jpg"
                            alt="Engagement social SACEM INDUSTRIES"
                            //style={{ maxHeight: "309px" }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="blog-detail" style={{ minHeight: "620px" }}>
                      <div className="entry-title mb-10">
                        <a href="#" onClick={handleClick}>
                          2026 PFE Internship Forum organized by École Centrale
                          Polytech / IT - Université Centrale Group
                        </a>
                      </div>
                      <div className="entry-meta mb-10">
                        <ul>
                          <li>
                            {" "}
                            <i className="fa fa-folder-open-o" />{" "}
                            <a href="#" onClick={handleClick}>
                              {" "}
                              SACEM Industries News{" "}
                            </a>{" "}
                          </li>

                          <li>
                            <a href="#" onClick={handleClick}>
                              <i className="fa fa-calendar-o" /> 26 November
                              2025
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="entry-content">
                        <p>
                          Our wonderful team presented several End-of-Study
                          Project (ESP) topics to students, with the aim of
                          strengthening the link between the academic and
                          professional worlds and offering future graduates
                          concrete opportunities for learning and innovation.
                        </p>
                        <p>
                          Thank you to the Université Centrale Group for the
                          warm welcome and impeccable organisation. We are
                          delighted to contribute to the training of tomorrow's
                          leaders.
                        </p>
                        <p>
                          Thanks also to our wonderful team: Mr Elyes Trabelsi
                          and Mr Saber Mhadhbi.
                        </p>
                        <p>
                          #PowerTransformer #EnergyInfrastructure
                          #IndustrialTechnology #SACEM #Transformer #Tunisia
                          #Africa
                        </p>
                      </div>
                    </div>
                    <div
                      className="entry-share clearfix"
                      style={{
                        marginTop: "0px",
                        paddingBottom: "1.25rem",
                        paddingRight: "1.25rem",
                        paddingTop: "0.5rem",
                      }}
                    >
                      <div className="social list-style-none float-right">
                        <strong>Follow us: </strong>
                        <ul>
                          <li>
                            <a href="https://www.facebook.com/sacemgroup/?locale=fr_FR">
                              {" "}
                              <i className="fa fa-facebook" />{" "}
                            </a>
                          </li>
                          <li>
                            <a href="https://fr.linkedin.com/company/sacem-group">
                              {" "}
                              <i className="fa ti-linkedin" />{" "}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                {/** actu 2 */}
                <div className="col-lg-6 col-md-6 col-sm-6">
                  <div className="blog-entry mb-50">
                    <div className="entry-image clearfix">
                      <div
                        className="owl-carousel bottom-center-dots"
                        data-nav-dots="ture"
                        data-items={1}
                        data-md-items={1}
                        data-sm-items={1}
                        data-xs-items={1}
                        data-xx-items={1}
                      >
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/ecole primaire1/ep1.jpg"
                            alt="Engagement social SACEM INDUSTRIES"
                            //style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/ecole primaire1/ep2.jpg"
                            alt="Engagement social SACEM INDUSTRIES"
                            //style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/ecole primaire1/ep3.jpg"
                            alt="Engagement social SACEM INDUSTRIES"
                            //style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/ecole primaire1/ep4.jpg"
                            alt="Engagement social SACEM INDUSTRIES"
                            //style={{ maxHeight: "309px" }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="blog-detail" style={{ minHeight: "620px" }}>
                      <div className="entry-title mb-10">
                        <a href="#" onClick={handleClick}>
                          SACEM GROUP social commitment - Hay Al-Arish
                          neighborhood elementary school - Tinga
                        </a>
                      </div>
                      <div className="entry-meta mb-10">
                        <ul>
                          <li>
                            {" "}
                            <i className="fa fa-folder-open-o" />{" "}
                            <a href="#" onClick={handleClick}>
                              {" "}
                              SACEM Industries News{" "}
                            </a>{" "}
                          </li>

                          <li>
                            <a href="#" onClick={handleClick}>
                              <i className="fa fa-calendar-o" /> Septembre 2025
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="entry-content">
                        <p>
                          As part of its social commitment, SACEM INDUSTRIES
                          installed a new door and maintained another door at
                          the primary school in the Hay Al-Arish - Tinga
                          neighborhood, thereby helping to improve school
                          conditions and provide a safer environment for our
                          children.
                        </p>
                        <p>
                          Mr. Khaled Kammoun, CEO of SACEM GROUP, also wishes
                          good luck and success to our students at all levels
                          and extends his sincere thanks and gratitude to our
                          employees who contributed to the success of this
                          initiative through their efforts.
                        </p>
                        <p>Together, we make a positive impact ✨.</p>
                      </div>
                    </div>
                    <div
                      className="entry-share clearfix"
                      style={{
                        marginTop: "0px",
                        paddingBottom: "1.25rem",
                        paddingRight: "1.25rem",
                        paddingTop: "0.5rem",
                      }}
                    >
                      <div className="social list-style-none float-right">
                        <strong>Follow us: </strong>
                        <ul>
                          <li>
                            <a href="https://www.facebook.com/sacemgroup/?locale=fr_FR">
                              {" "}
                              <i className="fa fa-facebook" />{" "}
                            </a>
                          </li>
                          <li>
                            <a href="https://fr.linkedin.com/company/sacem-group">
                              {" "}
                              <i className="fa ti-linkedin" />{" "}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/** row 2 */}
              <div className="row">
                {/** actu 1 */}
                <div className="col-lg-6 col-md-6 col-sm-6">
                  <div className="blog-entry mb-50">
                    <div className="entry-image clearfix">
                      <div
                        className="owl-carousel bottom-center-dots"
                        data-nav-dots="ture"
                        data-items={1}
                        data-md-items={1}
                        data-sm-items={1}
                        data-xs-items={1}
                        data-xx-items={1}
                      >
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/ecole primaire2/ep1.jpg"
                            alt="SACEM INDUSTRIES social commitment"
                            //style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/ecole primaire2/ep2.jpg"
                            alt="SACEM INDUSTRIES social commitment"
                            //style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/ecole primaire2/ep3.jpg"
                            alt="SACEM INDUSTRIES social commitment"
                            //style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/ecole primaire2/ep4.jpg"
                            alt="SACEM INDUSTRIES social commitment"
                            //style={{ maxHeight: "309px" }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="blog-detail" style={{ minHeight: "616px" }}>
                      <div className="entry-title mb-10">
                        <a href="#" onClick={handleClick}>
                          SACEM GROUP social commitment - Hay Al Najah Zaghaba
                          neighborhood elementary school
                        </a>
                      </div>
                      <div className="entry-meta mb-10">
                        <ul>
                          <li>
                            {" "}
                            <i className="fa fa-folder-open-o" />{" "}
                            <a href="#" onClick={handleClick}>
                              {" "}
                              SACEM Industries News{" "}
                            </a>{" "}
                          </li>

                          <li>
                            <a href="#" onClick={handleClick}>
                              <i className="fa fa-calendar-o" /> Septembre 2025
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="entry-content">
                        <p>
                          As part of its social commitment, and at the request
                          of Mr. Ziad Harzallah, mayor of Manzel Bourguiba, and
                          Mr. Marwan Chalghoumi, member of the municipal
                          council, SACEM GROUP carried out renovation work at
                          the primary school in the Hay Al Najah Zaghaba
                          neighborhood, including the construction and repair of
                          part of the electrical network and maintenance of the
                          lighting, in order to contribute to the creation of a
                          better school environment for our children in the Al
                          Najah neighborhood.
                        </p>
                        <p>
                          M. Khaled Kammoun, directeur général de SACEM GROUP,
                          adresse ses sincères remerciements et sa gratitude à
                          nos employés qui ont participé à la réussite de cette
                          noble initiative.
                        </p>
                        <p>💡🌟 Together, we make a positive impact.🤝 💪</p>
                      </div>
                    </div>
                    <div
                      className="entry-share clearfix"
                      style={{
                        marginTop: "0px",
                        paddingBottom: "1.25rem",
                        paddingRight: "1.25rem",
                        paddingTop: "0.5rem",
                      }}
                    >
                      <div className="social list-style-none float-right">
                        <strong>Follow us: </strong>
                        <ul>
                          <li>
                            <a href="https://www.facebook.com/sacemgroup/?locale=fr_FR">
                              {" "}
                              <i className="fa fa-facebook" />{" "}
                            </a>
                          </li>
                          <li>
                            <a href="https://fr.linkedin.com/company/sacem-group">
                              {" "}
                              <i className="fa ti-linkedin" />{" "}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                {/** actu 2 */}
                <div className="col-lg-6 col-md-6 col-sm-6">
                  <div className="blog-entry mb-50">
                    <div className="entry-image clearfix">
                      <div
                        className="owl-carousel bottom-center-dots"
                        data-nav-dots="ture"
                        data-items={1}
                        data-md-items={1}
                        data-sm-items={1}
                        data-xs-items={1}
                        data-xx-items={1}
                      >
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/25MVA/25MVA.jpg"
                            alt="SACEM TRANSFORMER 25 MVA TUNISIE"
                            //style={{ maxHeight: "309px" }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="blog-detail" style={{ minHeight: "616px" }}>
                      <div className="entry-title mb-10">
                        <a href="#" onClick={handleClick}>
                          New Achievement: 25 MVA Power Transformer with our
                          partner IFRIQIYA INTERNATIONAL TRADE (ICI) on behalf
                          of Société Énergie Électrique du Congo (E2C)
                        </a>
                      </div>
                      <div className="entry-meta mb-10">
                        <ul>
                          <li>
                            {" "}
                            <i className="fa fa-folder-open-o" />{" "}
                            <a href="#" onClick={handleClick}>
                              {" "}
                              SACEM Industries News{" "}
                            </a>{" "}
                          </li>

                          <li>
                            <a href="#" onClick={handleClick}>
                              <i className="fa fa-calendar-o" /> June 2025
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="entry-content">
                        <p>
                          SACEM Industries has once again strengthened its
                          position as a regional leader in the manufacture of
                          power transformers in collaboration with our partner
                          IFRIQIYA INTERNATIONAL TRADE (ICI). We are proud to
                          announce the recent delivery of a 25 MVA three-phase
                          power transformer (30/20 kV – Dyn11 – ONAN) to the
                          Société Énergie Électrique du Congo (E2C).
                        </p>
                        <p>
                          This achievement demonstrates our ability to meet the
                          highest technical requirements while complying with
                          international standards of quality and performance.
                        </p>
                        <p>
                          This project reflects our ongoing commitment to
                          supporting African energy operators in the sustainable
                          development of our continent.
                        </p>
                        <p>
                          👏 Congratulations to our teams for their
                          professionalism and dedication in making this project
                          a success.
                        </p>
                      </div>
                    </div>
                    <div
                      className="entry-share clearfix"
                      style={{
                        marginTop: "0px",
                        paddingBottom: "1.25rem",
                        paddingRight: "1.25rem",
                        paddingTop: "0.5rem",
                      }}
                    >
                      <div className="social list-style-none float-right">
                        <strong>Follow us: </strong>
                        <ul>
                          <li>
                            <a href="https://www.facebook.com/sacemgroup/?locale=fr_FR">
                              {" "}
                              <i className="fa fa-facebook" />{" "}
                            </a>
                          </li>
                          <li>
                            <a href="https://fr.linkedin.com/company/sacem-group">
                              {" "}
                              <i className="fa ti-linkedin" />{" "}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* ROW 3*/}
              <div className="row">
                {/** actu 1 */}

                
                
                <div className="col-lg-6 col-md-6 col-sm-6">
                  <div className="blog-entry mb-50">
                    <div className="entry-image clearfix">
                      <div
                        className="owl-carousel bottom-center-dots"
                        data-nav-dots="ture"
                        data-items={1}
                        data-md-items={1}
                        data-sm-items={1}
                        data-xs-items={1}
                        data-xx-items={1}
                      >
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/agreement enib/enib1.jpg"
                            alt="collaboration agreement_SACEM_ENIB"
                            //style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/agreement enib/enib2.jpg"
                            alt="collaboration agreement_SACEM_ENIB"
                            //style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/agreement enib/enib3.jpg"
                            alt="collaboration agreement_SACEM_ENIB"
                            //style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/agreement enib/enib4.jpg"
                            alt="collaboration agreement_SACEM_ENIB"
                            // style={{ maxHeight: "309px" }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="blog-detail" style={{ minHeight: "500px" }}>
                      <div className="entry-title mb-10">
                        <a href="#" onClick={handleClick}>
                          The signing of a collaboration agreement.
                        </a>
                      </div>
                      <div className="entry-meta mb-10">
                        <ul>
                          <li>
                            {" "}
                            <i className="fa fa-folder-open-o" />{" "}
                            <a href="#" onClick={handleClick}>
                              {" "}
                              SACEM Industries News{" "}
                            </a>{" "}
                          </li>

                          <li>
                            <a href="#" onClick={handleClick}>
                              <i className="fa fa-calendar-o" /> 02 June 2025
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="entry-content">
                        <p>
                          Today, we had the pleasure of welcoming a delegation
                          from the #ENIB (National Engineering School of
                          Bizerte), led by Mr. Hakim Hammami, Director of #ENIB,
                          for a site visit and the signing of a collaboration
                          agreement.
                        </p>
                        <p>
                          This partnership marks a significant step forward in
                          strengthening ties between academia and industry. It
                          will foster new opportunities for internships,
                          final-year projects, and joint innovation initiatives.
                        </p>
                        <p>
                          🤝 A big thank you to #ENIB for their trust and
                          commitment. Together, we’re shaping the future of
                          industry and engineering education!
                        </p>
                      </div>
                    </div>
                    <div
                      className="entry-share clearfix"
                      style={{
                        marginTop: "0px",
                        paddingBottom: "1.25rem",
                        paddingRight: "1.25rem",
                        paddingTop: "0.5rem",
                      }}
                    >
                      <div className="social list-style-none float-right">
                        <strong>Follow us: </strong>
                        <ul>
                          <li>
                            <a href="https://www.facebook.com/sacemgroup/?locale=fr_FR">
                              {" "}
                              <i className="fa fa-facebook" />{" "}
                            </a>
                          </li>
                          <li>
                            <a href="https://fr.linkedin.com/company/sacem-group">
                              {" "}
                              <i className="fa ti-linkedin" />{" "}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                {/** actu 2 */}
                <div className="col-lg-6 col-md-6 col-sm-6">
                  <div className="blog-entry mb-50">
                    <div className="entry-image clearfix">
                      <div
                        className="owl-carousel bottom-center-dots"
                        data-nav-dots="ture"
                        data-items={1}
                        data-md-items={1}
                        data-sm-items={1}
                        data-xs-items={1}
                        data-xx-items={1}
                      >
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/Social Progress Award for 2024_SACEM_TRANSFORMATEUR_5.jpg"
                            alt="Social Progress Award for 2024 SACEM TRANSFORMATEUR"
                            // style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/Social Progress Award for 2024_SACEM_TRANSFORMATEUR_1.jpg"
                            alt="Social Progress Award for 2024 SACEM TRANSFORMATEUR"
                            //style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/Social Progress Award for 2024_SACEM_TRANSFORMATEUR_2.jpg"
                            alt="Social Progress Award for 2024 SACEM TRANSFORMATEUR"
                            //  style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/Social Progress Award for 2024_SACEM_TRANSFORMATEUR_3.jpg"
                            alt="Social Progress Award for 2024 SACEM TRANSFORMATEUR"
                            //  style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/Social Progress Award for 2024_SACEM_TRANSFORMATEUR_4.jpg"
                            alt="Social Progress Award for 2024 SACEM TRANSFORMATEUR"
                            // style={{ maxHeight: "309px" }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="blog-detail" style={{ minHeight: "500px" }}>
                      <div className="entry-title mb-10">
                        <a href="#" onClick={handleClick}>
                          Social Progress Award for 2024
                        </a>
                      </div>
                      <div className="entry-meta mb-10">
                        <ul>
                          <li>
                            {" "}
                            <i className="fa fa-folder-open-o" />{" "}
                            <a href="#" onClick={handleClick}>
                              {" "}
                              SACEM Industries News{" "}
                            </a>{" "}
                          </li>

                          <li>
                            <a href="#" onClick={handleClick}>
                              <i className="fa fa-calendar-o" /> 01 May 2025
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="entry-content">
                        <p>
                          On the occasion of International Workers' Day on May
                          1, 2025, SACEM Industries was honored by the Minister
                          of Social Affairs for receiving the Social Progress
                          Award for 2024.
                        </p>
                        <p>
                          {" "}
                          This recognition crowns years of dedication to
                          corporate social responsibility, in collaboration with
                          our social partners, civil society, and local
                          authorities.
                        </p>
                        <p>
                          On this occasion, the General Manager of SACEM Group,
                          M. Khaled Kammoun, extends his congratulations to all
                          employees. He also expresses his heartfelt thanks to
                          the members of the workers' representatives and the
                          consultative commission, who have been excellent
                          partners in achieving this award, which will serve as
                          a great incentive for further support of workers and
                          improvement of working conditions.
                        </p>
                      </div>
                    </div>
                    <div
                      className="entry-share clearfix"
                      style={{
                        marginTop: "0px",
                        paddingBottom: "1.25rem",
                        paddingRight: "1.25rem",
                        paddingTop: "0.5rem",
                      }}
                    >
                      <div className="social list-style-none float-right">
                        <strong>Follow us: </strong>
                        <ul>
                          <li>
                            <a href="https://www.facebook.com/sacemgroup/?locale=fr_FR">
                              {" "}
                              <i className="fa fa-facebook" />{" "}
                            </a>
                          </li>
                          <li>
                            <a href="https://fr.linkedin.com/company/sacem-group">
                              {" "}
                              <i className="fa ti-linkedin" />{" "}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              {/** row 4 */}
              <div className="row">
                {/** actu 1 */}

                
                
                <div className="col-lg-6 col-md-6 col-sm-6">
                  <div className="blog-entry mb-50">
                    <div className="entry-image clearfix">
                      <div
                        className="owl-carousel bottom-center-dots"
                        data-nav-dots="ture"
                        data-items={1}
                        data-md-items={1}
                        data-sm-items={1}
                        data-xs-items={1}
                        data-xx-items={1}
                      >
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/exercice secourisme/secourisme1.jpg"
                            alt="Night Exercise at SACEM Industries"
                            //  style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/exercice secourisme/secourisme2.jpg"
                            alt="Night Exercise at SACEM Industries"
                            // style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/exercice secourisme/secourisme3.jpg"
                            alt="Night Exercise at SACEM Industries"
                            //  style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/exercice secourisme/secourisme4.jpg"
                            alt="Night Exercise at SACEM Industries"
                            //  style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/exercice secourisme/secourisme5.jpg"
                            alt="Night Exercise at SACEM Industries"
                            //  style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/exercice secourisme/secourisme6.jpg"
                            alt="Night Exercise at SACEM Industries"
                            // style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/exercice secourisme/secourisme7.jpg"
                            alt="Night Exercise at SACEM Industries"
                            //  style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/exercice secourisme/secourisme8.jpg"
                            alt="Night Exercise at SACEM Industries"
                            //  style={{ maxHeight: "309px" }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="blog-detail" style={{ minHeight: "550px" }}>
                      <div className="entry-title mb-10">
                        <a href="#" onClick={handleClick}>
                          Night Exercise at SACEM Industries 🚒🧯
                        </a>
                      </div>
                      <div className="entry-meta mb-10">
                        <ul>
                          <li>
                            {" "}
                            <i className="fa fa-folder-open-o" />{" "}
                            <a href="#" onClick={handleClick}>
                              {" "}
                              Factory news{" "}
                            </a>{" "}
                          </li>

                          <li>
                            <a href="#" onClick={handleClick}>
                              <i className="fa fa-calendar-o" /> 24 April 2025
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="entry-content">
                        <p>
                          On April 24, 2025, SACEM Industries conducted a
                          night-time first-aid and fire-fighting exercise at our
                          electrical transformer plant in Menzel Bourguiba. Our
                          teams demonstrated their commitment and expertise in
                          safety and emergency management. Many thanks to all
                          participants for their dedication and professionalism.
                          Special thanks to the safety team, our colleagues in
                          the MAGNETIC CIRCUIT section and to MOHAMED ALI
                          MABROUK for their remarkable commitment.
                        </p>
                        <p>
                          Together, we ensure a safer working environment for
                          all. 💪🔥
                        </p>
                      </div>
                    </div>
                    <div
                      className="entry-share clearfix"
                      style={{
                        marginTop: "0px",
                        paddingBottom: "1.25rem",
                        paddingRight: "1.25rem",
                        paddingTop: "0.5rem",
                      }}
                    >
                      <div className="social list-style-none float-right">
                        <strong>Follow us: </strong>
                        <ul>
                          <li>
                            <a href="https://www.facebook.com/sacemgroup/?locale=fr_FR">
                              {" "}
                              <i className="fa fa-facebook" />{" "}
                            </a>
                          </li>
                          <li>
                            <a href="https://fr.linkedin.com/company/sacem-group">
                              {" "}
                              <i className="fa ti-linkedin" />{" "}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                {/** actu 2 */}
<div className="col-lg-6 col-md-6 col-sm-6">
                  <div className="blog-entry mb-50">
                    <div className="entry-image clearfix">
                      <div
                        className="owl-carousel bottom-center-dots"
                        data-nav-dots="ture"
                        data-items={1}
                        data-md-items={1}
                        data-sm-items={1}
                        data-xs-items={1}
                        data-xx-items={1}
                      >
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/Enib/enib3.jpg"
                            alt="SACEM sponsor enib"
                            //  style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/Enib/enib1.jpg"
                            alt="SACEM sponsor enib"
                            //   style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/Enib/enib2.jpg"
                            alt="SACEM sponsor enib"
                            //  style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/Enib/enib4.jpg"
                            alt="SACEM sponsor enib"
                            // style={{ maxHeight: "309px" }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="blog-detail" style={{ minHeight: "550px" }}>
                      <div className="entry-title mb-10">
                        <a href="#" onClick={handleClick}>
                          Participation as sponsor in the seminar on
                          "Geopolitics, Artificial Intelligence and Major Global
                          Trends" (ISG Bizerte).
                        </a>
                      </div>
                      <div className="entry-meta mb-10">
                        <ul>
                          <li>
                            {" "}
                            <i className="fa fa-folder-open-o" />{" "}
                            <a href="#" onClick={handleClick}>
                              {" "}
                              Factory news{" "}
                            </a>{" "}
                          </li>

                          <li>
                            <a href="#" onClick={handleClick}>
                              <i className="fa fa-calendar-o" /> 23 April 2025
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="entry-content">
                        <p>
                          SACEM Industries was honored to participate as a
                          sponsor in the seminar held on April 23, 2025, at the
                          Higher Institute of Business Administration in Bizerte
                          (ISG Bizerte), under the supervision of Mr. Nizar
                          Yaiche, and under the theme: "Geopolitics, Artificial
                          Intelligence, and Major Global Trends."
                        </p>
                        <p>
                          This event was organized by the National Engineering
                          School of Bizerte (ENIB), the Higher Institute of
                          Business Administration of Bizerte (ISG Bizerte), the
                          Preparatory Institute for Engineering Studies of
                          Bizerte (IPEIB), and the University of Carthage, along
                          with the clubs: AI Innovator ENIB, 4C IPEIB, and 4C
                          ISG Bizerte.
                        </p>
                        <p>
                          We extend our sincere thanks to the organizers for
                          their kind invitation and excellent organization.
                        </p>
                      </div>
                    </div>
                    <div
                      className="entry-share clearfix"
                      style={{
                        marginTop: "0px",
                        paddingBottom: "1.25rem",
                        paddingRight: "1.25rem",
                        paddingTop: "0.5rem",
                      }}
                    >
                      <div className="social list-style-none float-right">
                        <strong>Follow us: </strong>
                        <ul>
                          <li>
                            <a href="https://www.facebook.com/sacemgroup/?locale=fr_FR">
                              {" "}
                              <i className="fa fa-facebook" />{" "}
                            </a>
                          </li>
                          <li>
                            <a href="https://fr.linkedin.com/company/sacem-group">
                              {" "}
                              <i className="fa ti-linkedin" />{" "}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              {/** row 5 */}
              <div className="row">
                {/** actu 1*/}
                
                
                <div className="col-lg-6 col-md-6 col-sm-6">
                  <div className="blog-entry mb-50">
                    <div className="entry-image clearfix">
                      <div
                        className="owl-carousel bottom-center-dots"
                        data-nav-dots="ture"
                        data-items={1}
                        data-md-items={1}
                        data-sm-items={1}
                        data-xs-items={1}
                        data-xx-items={1}
                      >
                        {/* <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/Op-blanche01-01.jpg"
                            alt="action blanche SACEM"
                          />
                        </div>
                        */}

                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/iso-sacem.jpg"
                            alt="Certification successfully renewed SACEM Industries"
                            //  style={{ maxHeight: "309px" }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="blog-detail" style={{ minHeight: "500px" }}>
                      <div>
                        <div className="entry-title mb-10">
                          <a href="#" onClick={handleClick}>
                            Certification successfully renewed!
                          </a>
                        </div>
                        <div className="entry-meta mb-10">
                          <ul>
                            <li>
                              {" "}
                              <i className="fa fa-folder-open-o" />{" "}
                              <a href="#" onClick={handleClick}>
                                {" "}
                                SACEM Industries News{" "}
                              </a>{" "}
                            </li>

                            <li>
                              <a href="#" onClick={handleClick}>
                                <i className="fa fa-calendar-o" /> 18 April 2025
                              </a>
                            </li>
                          </ul>
                        </div>
                        <div className="entry-content">
                          <p>
                            We are proud to announce that our integrated
                            management system (Quality, Safety, Environment) has
                            been successfully audited, resulting in the renewal
                            of our certifications:
                          </p>
                          <p>✅ ISO 9001:2015 </p>
                          <p>✅ ISO 14001:2015</p>
                          <p>✅ ISO 45001:2018</p>
                          <p>
                            The audit highlighted the commitment of our teams
                            and the solidity of our organization.{" "}
                          </p>
                          <p>
                            👏 Many thanks to all our employees for their
                            dedication, commitment and contribution to this
                            collective success. Together, we continue to
                            progress and strive for excellence.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      className="entry-share clearfix"
                      style={{
                        marginTop: "0px",
                        paddingBottom: "1.25rem",
                        paddingRight: "1.25rem",
                        paddingTop: "0.5rem",
                      }}
                    >
                      <div className="social list-style-none float-right">
                        <strong>Follow us: </strong>
                        <ul>
                          <li>
                            <a href="https://www.facebook.com/sacemgroup/?locale=fr_FR">
                              {" "}
                              <i className="fa fa-facebook" />{" "}
                            </a>
                          </li>
                          <li>
                            <a href="https://fr.linkedin.com/company/sacem-group">
                              {" "}
                              <i className="fa ti-linkedin" />{" "}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                {/** actu 2*/}
<div className="col-lg-6 col-md-6 col-sm-6">
                  <div className="blog-entry mb-50">
                    <div className="entry-image clearfix">
                      <div
                        className="owl-carousel bottom-center-dots"
                        data-nav-dots="ture"
                        data-items={1}
                        data-md-items={1}
                        data-sm-items={1}
                        data-xs-items={1}
                        data-xx-items={1}
                      >
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/Op-blanche01-01.jpg"
                            alt="White action for fire-fighting SACEM"
                            style={{ height: "381px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/Op-blanche02-02.jpg"
                            alt="White action for fire-fighting SACEM"
                            style={{ height: "381px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/Op-blanche03-03.jpg"
                            alt="White action for fire-fighting SACEM"
                            style={{ height: "381px" }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="blog-detail" style={{ minHeight: "500px" }}>
                      <div
                        className="entry-title mb-10"
                        style={{ height: "60px" }}
                      >
                        <a href="#" onClick={handleClick}>
                          White action for fire-fighting, evacuation and first
                          aid.
                        </a>
                      </div>
                      <div className="entry-meta mb-10">
                        <ul>
                          <li>
                            {" "}
                            <i className="fa fa-folder-open-o" />{" "}
                            <a href="#" onClick={handleClick}>
                              {" "}
                              Factory news{" "}
                            </a>{" "}
                          </li>

                          <li>
                            <a href="#" onClick={handleClick}>
                              <i className="fa fa-calendar-o" /> 02 December
                              2024
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="entry-content">
                        <p>
                          A look back at the white action for firefighting
                          evacuation and first aid. Thanks to the team of the
                          civil protection of menzel Bourguiba and to the staff
                          of SACEM GROUP for the smooth running of the action.
                        </p>
                      </div>
                    </div>
                    <div
                      className="entry-share clearfix"
                      style={{
                        marginTop: "0px",
                        paddingBottom: "1.25rem",
                        paddingRight: "1.25rem",
                        paddingTop: "0.5rem",
                      }}
                    >
                      <div className="social list-style-none float-right">
                        <strong>Follow us: </strong>
                        <ul>
                          <li>
                            <a href="https://www.facebook.com/sacemgroup/?locale=fr_FR">
                              {" "}
                              <i className="fa fa-facebook" />{" "}
                            </a>
                          </li>
                          <li>
                            <a href="https://fr.linkedin.com/company/sacem-group">
                              {" "}
                              <i className="fa ti-linkedin" />{" "}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              {/* ROW5 */}
              <div className="row">
                {/** actu 1 */}
                
                
                <div className="col-lg-6 col-md-6 col-sm-6">
                  <div className="blog-entry mb-50">
                    <div className="entry-image clearfix">
                      <div
                        className="owl-carousel bottom-center-dots"
                        data-nav-dots="ture"
                        data-items={1}
                        data-md-items={1}
                        data-sm-items={1}
                        data-xs-items={1}
                        data-xx-items={1}
                      >
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/ACT2.jpg"
                            alt="social responsibility SACEM"
                            style={{ maxHeight: "381px" }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="blog-detail" style={{ minHeight: "348px" }}>
                      <div
                        className="entry-title mb-10"
                        style={{ height: "60px" }}
                      >
                        <a href="#" onClick={handleClick}>
                          Rehabilitation of the Tinja public library
                        </a>
                      </div>
                      <div className="entry-meta mb-10">
                        <ul>
                          <li>
                            {" "}
                            <i className="fa fa-folder-open-o" />{" "}
                            <a href="#" onClick={handleClick}>
                              {" "}
                              Factory news{" "}
                            </a>{" "}
                          </li>

                          <li>
                            <a href="#" onClick={handleClick}>
                              <i className="fa fa-calendar-o" /> 27 Septembre
                              2024
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="entry-content">
                        <p>
                          As part of the company's social responsibility
                          responsibility, and on the instructions of Mr Khaled
                          Kammoun ,Managing Director of the SACEM Group, a
                          number of were carried out to carry out maintenance
                          and repair work to refurbish the Tinja public library.
                        </p>
                      </div>
                    </div>
                    <div
                      className="entry-share clearfix"
                      style={{
                        marginTop: "0px",
                        paddingBottom: "1.25rem",
                        paddingRight: "1.25rem",
                        paddingTop: "0.5rem",
                      }}
                    >
                      <div className="social list-style-none float-right">
                        <strong>Follow us: </strong>
                        <ul>
                          <li>
                            <a href="https://www.facebook.com/sacemgroup/?locale=fr_FR">
                              {" "}
                              <i className="fa fa-facebook" />{" "}
                            </a>
                          </li>
                          <li>
                            <a href="https://fr.linkedin.com/company/sacem-group">
                              {" "}
                              <i className="fa ti-linkedin" />{" "}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                {/** actu 2 */}
<div className="col-lg-6 col-md-6 col-sm-6">
                  <div className="blog-entry mb-50">
                    <div className="entry-image clearfix">
                      <div
                        className="owl-carousel bottom-center-dots"
                        data-nav-dots="ture"
                        data-items={1}
                        data-md-items={1}
                        data-sm-items={1}
                        data-xs-items={1}
                        data-xx-items={1}
                      >
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/sans-tabac.jpg"
                            alt="No-Smoking Day SACEM"
                            style={{ maxHeight: "381px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/san-tabac2.jpg"
                            alt="No-Smoking Day SACEM"
                            style={{ maxHeight: "381px" }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="blog-detail" style={{ minHeight: "381px" }}>
                      <div className="entry-title mb-10">
                        <a href="#" onClick={handleClick}>
                          World No-Smoking Day
                        </a>
                      </div>
                      <div className="entry-meta mb-10">
                        <ul>
                          <li>
                            {" "}
                            <i className="fa fa-folder-open-o" />{" "}
                            <a href="#" onClick={handleClick}>
                              {" "}
                              Factory news{" "}
                            </a>{" "}
                          </li>

                          <li>
                            <a href="#" onClick={handleClick}>
                              <i className="fa fa-calendar-o" /> 31 May 2024
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="entry-content">
                        <p>
                          To mark World No Tobacco Day on 31 2024, an
                          awareness-raising day was held at the organised at the
                          Sacem Industries factory in Menzel Bourguiba-Tinja for
                          the benefit of workers and employees on the harmful
                          effects of smoking and its negative repercussions
                          health, in collaboration with the regional health
                          directorate in Bizerte and the occupational medicine
                          complex in Bizerte.
                        </p>
                      </div>
                    </div>
                    <div
                      className="entry-share clearfix"
                      style={{
                        marginTop: "0px",
                        paddingBottom: "1.25rem",
                        paddingRight: "1.25rem",
                        paddingTop: "0.5rem",
                      }}
                    >
                      <div className="social list-style-none float-right">
                        <strong>Follow us: </strong>
                        <ul>
                          <li>
                            <a href="https://www.facebook.com/sacemgroup/?locale=fr_FR">
                              {" "}
                              <i className="fa fa-facebook" />{" "}
                            </a>
                          </li>
                          <li>
                            <a href="https://fr.linkedin.com/company/sacem-group">
                              {" "}
                              <i className="fa ti-linkedin" />{" "}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              {/** row 6*/}
              <div className="row">
                {/**actu 1 */}
                
                
                <div className="col-lg-6 col-md-6 col-sm-6">
                  <div className="blog-entry mb-50">
                    <div className="entry-image clearfix">
                      <div
                        className="owl-carousel bottom-center-dots"
                        data-nav-dots="ture"
                        data-items={1}
                        data-md-items={1}
                        data-sm-items={1}
                        data-xs-items={1}
                        data-xx-items={1}
                      >
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/esprit1.jpg"
                            alt="ESPRIT SACEM"
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/esprit.jpg"
                            alt="ESPRIT SACEM"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="blog-detail" style={{ minHeight: "348px" }}>
                      <div>
                        <div className="entry-title mb-10">
                          <a href="#" onClick={handleClick}>
                            Welcomes students from ESPRIT
                          </a>
                        </div>
                        <div className="entry-meta mb-10">
                          <ul>
                            <li>
                              {" "}
                              <i className="fa fa-folder-open-o" />{" "}
                              <a href="#" onClick={handleClick}>
                                {" "}
                                Factory news{" "}
                              </a>{" "}
                            </li>

                            <li>
                              <a href="#" onClick={handleClick}>
                                <i className="fa fa-calendar-o" /> 08 May 2024
                              </a>
                            </li>
                          </ul>
                        </div>
                        <div className="entry-content">
                          <p>
                            Welcomes students from ESPRIT: École Supérieure
                            École Supérieure d'Ingénierie et de Technologies in
                            our transformer factory. We gave them a detailed
                            presentation manufacturing process for the various
                            components of the electrical transformer.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      className="entry-share clearfix"
                      style={{
                        marginTop: "0px",
                        paddingBottom: "1.25rem",
                        paddingRight: "1.25rem",
                        paddingTop: "0.5rem",
                      }}
                    >
                      <div className="social list-style-none float-right">
                        <strong>Follow us: </strong>
                        <ul>
                          <li>
                            <a href="https://www.facebook.com/sacemgroup/?locale=fr_FR">
                              {" "}
                              <i className="fa fa-facebook" />{" "}
                            </a>
                          </li>
                          <li>
                            <a href="https://fr.linkedin.com/company/sacem-group">
                              {" "}
                              <i className="fa ti-linkedin" />{" "}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                {/**actu 2 */}
<div className="col-lg-6 col-md-6 col-sm-6">
                  <div className="blog-entry mb-50">
                    <div className="entry-image clearfix">
                      <div
                        className="owl-carousel bottom-center-dots"
                        data-nav-dots="ture"
                        data-items={1}
                        data-md-items={1}
                        data-sm-items={1}
                        data-xs-items={1}
                        data-xx-items={1}
                      >
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/Petanque.jpg"
                            alt="Petanque SACEM"
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/Petanque1.jpg"
                            alt="Petanque SACEM"
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/Petanque2.jpg"
                            alt="Petanque SACEM"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="blog-detail" style={{ minHeight: "348px" }}>
                      <div
                        className="entry-title mb-10"
                        style={{ height: "60px" }}
                      >
                        <a href="#" onClick={handleClick}>
                          First Friendly Tournament Petanque
                        </a>
                      </div>
                      <div className="entry-meta mb-10">
                        <ul>
                          <li>
                            {" "}
                            <i className="fa fa-folder-open-o" />{" "}
                            <a href="#" onClick={handleClick}>
                              {" "}
                              Factory news{" "}
                            </a>{" "}
                          </li>

                          <li>
                            <a href="#" onClick={handleClick}>
                              <i className="fa fa-calendar-o" /> 18 February
                              2024
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="entry-content">
                        <p>
                          SACEM GROUP would like to thank all the participants
                          of the first friendly petanque tournament on 18
                          February 2024 at the SACEM Sports Complex. It also
                          congratulates the winners of union Menzlien of
                          Petanque and the Tinja Youth Association and wishes
                          them more brilliance in the upcoming competitions.
                        </p>
                      </div>
                    </div>
                    <div
                      className="entry-share clearfix"
                      style={{
                        marginTop: "0px",
                        paddingBottom: "1.25rem",
                        paddingRight: "1.25rem",
                        paddingTop: "0.5rem",
                      }}
                    >
                      <div className="social list-style-none float-right">
                        <strong>Follow us: </strong>
                        <ul>
                          <li>
                            <a href="https://www.facebook.com/sacemgroup/?locale=fr_FR">
                              {" "}
                              <i className="fa fa-facebook" />{" "}
                            </a>
                          </li>
                          <li>
                            <a href="https://fr.linkedin.com/company/sacem-group">
                              {" "}
                              <i className="fa ti-linkedin" />{" "}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              {/* ROW7 */}
              <div className="row">
                {/**actu1 */}
                
                
                <div className="col-lg-6 col-md-6 col-sm-6">
                  <div className="blog-entry mb-50">
                    <div className="entry-image clearfix">
                      <div
                        className="owl-carousel bottom-center-dots"
                        data-nav-dots="ture"
                        data-items={1}
                        data-md-items={1}
                        data-sm-items={1}
                        data-xs-items={1}
                        data-xx-items={1}
                      >
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/ELEK_ENER_2023.jpg"
                            alt="Renewable Energies SACEM"
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/ELEK_ENER_2023_3.jpg"
                            alt="Renewable Energies SACEM"
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/ELEK_ENER_2023_2.jpg"
                            alt="Renewable Energies SACEM"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="blog-detail" style={{ minHeight: "348px" }}>
                      <div>
                        <div className="entry-title mb-10">
                          <a
                            href="#"
                            onClick={handleClick}
                            style={{ height: "60px" }}
                          >
                            Electricity and Renewable Energies Exhibition ELEK
                            ENER 2023
                          </a>
                        </div>
                        <div className="entry-meta mb-10">
                          <ul>
                            <li>
                              {" "}
                              <i className="fa fa-folder-open-o" />{" "}
                              <a href="#" onClick={handleClick}>
                                {" "}
                                Factory news{" "}
                              </a>{" "}
                            </li>

                            <li>
                              <a href="#" onClick={handleClick}>
                                <i className="fa fa-calendar-o" /> 11 to 15
                                October 2023
                              </a>
                            </li>
                          </ul>
                        </div>
                        <div className="entry-content">
                          <p>
                            A look back at our participation in the 2nd ELEK
                            ENER 2023 Electricity and Renewable Energy
                            Exhibition, held from 11 to 15 October at the Kram
                            Exhibition Centre in Tunis, with our partner Medelec
                            Switchgear.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      className="entry-share clearfix"
                      style={{
                        marginTop: "0px",
                        paddingBottom: "1.25rem",
                        paddingRight: "1.25rem",
                        paddingTop: "0.5rem",
                      }}
                    >
                      <div className="social list-style-none float-right">
                        <strong>Follow us: </strong>
                        <ul>
                          <li>
                            <a href="https://www.facebook.com/sacemgroup/?locale=fr_FR">
                              {" "}
                              <i className="fa fa-facebook" />{" "}
                            </a>
                          </li>
                          <li>
                            <a href="https://fr.linkedin.com/company/sacem-group">
                              {" "}
                              <i className="fa ti-linkedin" />{" "}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                {/**actu2 */}
              </div>
            </div>
          </section>
        </div>
      </div>
      <div>
        <Footer_en />
      </div>
    </div>
  );
};

export default Actualites_en;
